import React from "react";
import "./userOrderCard.scss";
import {
  Avatar,
  Divider,
  Rating,
  Skeleton,
  Stack,
  useMediaQuery,
} from "@mui/material";

// Icon
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";

const UserOrderCardSkeleton = () => {
  const matches700 = useMediaQuery("(max-width:700px)");

  return (
    <div className="my-order-card">
      <Stack
        spacing={2}
        direction="row"
        sx={{
          borderBottom: "1px solid #c3e0e5",
          pb: 1,
          transition: "all 0.5s ease",
        }}
      >
        <Skeleton variant="circular" animation="wave">
          <Avatar />
        </Skeleton>
        <div className="delivery-status-and-date" style={{ width: "100%" }}>
          <div className="delivery-status">
            <Skeleton animation="wave" width={matches700 ? "30%" : "15%"} />
          </div>

          <div className="delivery-date">
            <Skeleton animation="wave" width={matches700 ? "60%" : "30%"} />
          </div>
        </div>
      </Stack>
      <div className="order-product">
        <Stack spacing={2} direction="row">
          <div className="order-product-image">
            <Skeleton animation="wave" component="img" />
          </div>
          <div
            className="order-product-basic-details"
            style={{ width: "100%" }}
          >
            <div className="order-product-name">
              <Skeleton animation="wave" width="30%" />
            </div>
            <div className="order-product-description">
              <Skeleton animation="wave" width="100%" />
            </div>
            <div
              className="order-product-size"
              style={{ display: "flex", alignItems: "center" }}
            >
              Size: <Skeleton animation="wave" width="30%" sx={{ ml: "5px" }} />
            </div>
            <div
              className="order-product-color"
              style={{ display: "flex", alignItems: "center" }}
            >
              Color:{" "}
              <Skeleton animation="wave" width="30%" sx={{ ml: "5px" }} />
            </div>
          </div>
        </Stack>
      </div>

      <Divider />
      <div className="return-product">
        <div className="is-return">
          <p style={{ width: "100%" }}>
            <Skeleton animation="wave" width="40%" />
          </p>
        </div>
      </div>
      <Divider />
      <div className="product-rating">
        <p>Rate Product</p>
        <Skeleton animation="wave" width="30%" sx={{ ml: "15px" }}>
          <Rating
            name="order-product-rating"
            className="order-product-rating"
            icon={<StarRateRoundedIcon fontSize="inherit" />}
            emptyIcon={<StarOutlineRoundedIcon fontSize="inherit" />}
            readOnly
          />
        </Skeleton>
      </div>
    </div>
  );
};

export default UserOrderCardSkeleton;
